<div class="pr-3 pl-4 h-full w-full flex flex-col" (window:resize)="onResize()">
  <div class="flex justify-between header-table" #pageOptionBtnGroup>
    <div class="title-page"><span class="title">Danh mục tình trạng việc làm&nbsp;</span>
      <breadcrumbs [items]="breadcrumbs"></breadcrumbs>
    </div>
    <div class="btn-option flex">
      <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
        <button class="flex items-center justify-center text-green-600" nz-button nzTooltipTitle="Thêm"
          nzTooltipPlacement="bottom" nz-tooltip (click)="Add()">
          <i nz-icon nzType="plus" nzTheme="outline"></i>
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
        <button class="flex items-center justify-center" nz-button (click)="Add()">Thêm
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
        <button class="flex items-center justify-center" nz-button (click)="Add()">
          <i nz-icon nzType="plus" nzTheme="outline"></i>
          Thêm
        </button>
      </ng-container>
    </div>
  </div>
  <form nz-form class="ant-advanced-search-form" #pageSearch>
    <div nz-row [nzGutter]="24">
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="quanHuyen">Tìm kiếm</nz-form-label>
          <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
            <input nz-input [(ngModel)]="commonFilter.name ? commonFilter.name : commonFilter.code"
              [ngModelOptions]="{standalone: true}" type="text" placeholder="Nhập" aria-label="Search" />
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <div nz-row>
      <div nz-col [nzSpan]="24" class="search-area">
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="reload()">Tìm
            kiếm</button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
          <button nz-button class="flex items-center justify-center" style="width: 100px;" [nzType]="'primary'"
            nzTooltipTitle="Tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip (click)="search()"><i nz-icon
              nzType="search" nzTheme="outline"></i></button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
          <button nz-button class="flex items-center justify-center" (click)="resetForm()" nzTooltipTitle="Xóa tìm kiếm"
            nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'"><i nz-icon nzType="search"
              nzTheme="outline"></i>Tìm kiếm</button>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="relative">
    <nz-table [nzShowTotal]="rangeTemplate" #Table nzOuterBordered nzShowSizeChanger [nzData]="dataList" nzSize="small"
      [nzScroll]="{x: width +'px', y: height + 'px'}" class="absolute w-full" [nzTotal]="Total" [nzPageSize]="pageSize"
      [nzPageIndex]="pageIndex" [nzPageSizeOptions]="pageSizeOptions" (nzPageIndexChange)="pageIndexEvent($event)"
      (nzPageSizeChange)="pageSizeEvent($event)" [nzShowTotal]="rangeTemplate">
      <thead>
        <tr #pageHeaderTable>
          <th nzWidth="50px" nzLeft>STT</th>
          <th nzWidth="180px" nzLeft>Mã tình trạng việc làm</th>
          <th [nzSortFn]="sortFn">Tình trạng việc làm</th>
          <th nzWidth="100px" class="text-center">Chưa đi làm</th>
          <th nzWidth="100px" class="text-center">Nghỉ việc</th>
          <th nzWidth="100px" class="text-center">Đang đi làm</th>
          <th nzRight nzWidth="60px"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of Table.data; let i = index">
          <td nzLeft>{{ i + 1 + (pageIndex-1)*pageSize }}</td>
          <td nzLeft>{{ data.code }}</td>
          <td>{{ data.name }}</td>
          <td class="text-center"><label nz-checkbox [ngModel]="data.isNotWorking" nzDisabled="true"></label></td>
          <td class="text-center"><label nz-checkbox [ngModel]="data.isQuitJob" nzDisabled="true"></label></td>
          <td class="text-center"><label nz-checkbox [ngModel]="data.isWorking" nzDisabled="true"></label></td>
          <td nzRight>
            <div nz-space nzAlign="end" class="space-align-block">
              <nz-space-item>
                <a class="text-blue-600" nzTooltipTitle="Sửa" nzTooltipPlacement="top" nz-tooltip (click)="Edit(data)">
                  <i nz-icon nzType="edit" nzTheme="outline"></i>
                </a>
              </nz-space-item>
              <nz-space-item>
                <a class="text-red-600" nzTooltipTitle="Xóa" nzTooltipPlacement="top" nz-tooltip
                  (click)="showDelete(data)">
                  <i nz-icon nzType="delete" nzTheme="outline"></i>
                </a>
              </nz-space-item>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
<ng-template #rangeTemplate let-range="range" let-total> {{ range[0] }}-{{ range[1] }} của {{ Total }} </ng-template>
.<ng-template #tplTitle>
  <div class="flex justify-between">
    <span>Thông tin tình trạng việc làm</span>
    <button nz-button class="btn-modal-reside" (click)="handlerResizePopup()">
      <i nz-icon [nzType]="!isResizdePopup ? 'arrows-alt': 'shrink'" nzTheme="outline"></i>
    </button>
  </div>
</ng-template>
